module.exports = __webpack_public_path__ + "static/magento-2a6e5a0be2d037e45708cb708d280475.jpg";